module.exports = __webpack_public_path__ + "img/Container01.0df08c0b.jpg";